import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartOnSiteLocationBlockConfig } from '@front-platform/content-builder';
import { cartOnSiteLocationBlockResolveConfig } from '@front-platform/content-builder';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnDestroy, OnInit, input } from '@angular/core';

import { DoodCartModel } from '@core/models/cart.model';
import { OrderTypeValues } from '@config/values/order.values';
import { ModalsService } from '@core/services/modals/modals.service';
import { CartStoreSelector } from '@common/selectors/cart.selector';
import { CartParametersModalComponent } from '@shared/modals/cart-parameters-modal/cart-parameters-modal.component';
export interface CartOnSiteLocationBlockRuntimeConfig {
  'heading'?: any;
}

export type CartOnSiteLocationBlockConfigInput = Partial<
  Omit<CartOnSiteLocationBlockConfig, keyof CartOnSiteLocationBlockRuntimeConfig> &
    CartOnSiteLocationBlockRuntimeConfig
>;
export type CartOnSiteLocationBlockResolvedConfig = Omit<
  CartOnSiteLocationBlockConfig,
  keyof CartOnSiteLocationBlockRuntimeConfig
> &
  Partial<CartOnSiteLocationBlockRuntimeConfig>;
export interface CartOnSiteLocationBlockContract extends ConfigComponentContract<
  CartOnSiteLocationBlockConfigInput,
  CartOnSiteLocationBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-on-site-location-block',
  templateUrl: './cart-on-site-location-block.component.html',
  standalone: false,
})
export class CartOnSiteLocationBlockComponent
  implements OnInit, OnDestroy, CartOnSiteLocationBlockContract
{
  readonly config = input<CartOnSiteLocationBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartOnSiteLocationBlockConfig,
    CartOnSiteLocationBlockRuntimeConfig
  >(cartOnSiteLocationBlockResolveConfig, () => ({ config: this.config() }));
  get heading(): any {
    return this.resolvedConfig()['heading'] as unknown as any;
  }

  isOnSiteOrdering = false;
  onSiteLocationName?: string;

  private destroyed$ = new Subject<boolean>();

  constructor(
    private cartSelector: CartStoreSelector,
    private readonly translate: TranslateService,
    private readonly modalsService: ModalsService,
  ) {}

  ngOnInit(): void {
    this.cartSelector.selectActive$.pipe(tap(cart => this.cartLoaded(cart))).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  openOnSiteLocationPickerModal(): void {
    this.modalsService.open(CartParametersModalComponent.handle);
  }

  private cartLoaded(cart: DoodCartModel | null): void {
    if (!cart) {
      this.isOnSiteOrdering = false;
      return;
    }

    this.onSiteLocationName = cart.on_site_location_name;
    this.isOnSiteOrdering = cart.type === OrderTypeValues.OnSite;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartOnSiteLocationBlockComponent, {
  'keyAliases': {},
});
